<ion-grid lines="none" mode="ios" class="title-with-back-button-text">
    <ion-row align-items-center>
        <ion-col offset="3" size-md="6" size-xs="4" style="text-align: center">
            <ion-label (click)="openFilters()" class="ion-text-center ion-text-wrap">
                {{ performanceCycle.title }}
            </ion-label>
        </ion-col>
        <ion-col size-md="2" size-xs="2">
        </ion-col>
        <ion-col size-md="1" size-xs="2">
            <svg xmlns="http://www.w3.org/2000/svg" width="27.41" height="30" viewBox="0 0 27.41 30"
                 (click)="openFilters()" class="filter-icon">
                <path id="Filter_Icon" data-name="Filter_Icon"
                      d="M522.214,225.509l-10.05,13.706h-.1l-1.173,14.447-3.83,1.846-1.488-16.293h-.111L494.8,225.509Z"
                      transform="translate(-494.803 -225.509)"
                />
            </svg>
        </ion-col>

    </ion-row>

</ion-grid>

<div class="filters">
    <span class="filter-item" *ngFor="let filter of selectedFilters; let i = index">
        {{ filter.name | translate }}
        <ion-icon (click)="removeFilter(i)" class="bp-close filter-remove"></ion-icon>
    </span>
</div>

<div class="progress-chart">
    <ion-row llrm>
        <ng-container *ngFor="let process of performanceCycle.processes">
            <ion-col size="12" size-sm="6" size-lg="3">
                <ion-card mode="ios" class="card-progress-status ion-text-center">
                    <ion-card-header>
                        <ion-card-title>
                            {{ getText(process.globalizationConfig, 'title') }}
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div class="chart-content">
                            <app-cycle-progress-chart
                                    [current]="process.finishedAmount"
                                    [total]="(process.unfinishedAmount + process.finishedAmount)"
                                    [isLoadingSteps]="isLoadingSteps"
                            ></app-cycle-progress-chart>
                        </div>
                    </ion-card-content>
                    <div class="card-footer">
                        <ion-button mode="ios" fill="clear" (click)="viewUsers(process)">
                            {{ 'generic.view' | translate }}
                        </ion-button>
                        <ion-button *ngIf="canManageSteps" mode="ios" fill="clear" [disabled]="performanceCycle.closed" (click)="enableStep(process)">
                            {{ 'processParticipants.enableStep' | translate }}
                        </ion-button>
                        <ion-button *ngIf="canManageSteps" mode="ios" fill="clear" [disabled]="performanceCycle.closed" (click)="openConfirmCloseStepModal(process)">
                            {{ 'generic.close' | translate }}
                        </ion-button>
                    </div>
                </ion-card>
            </ion-col>
        </ng-container>
    </ion-row>
</div>